import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './StudentDataModal.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { StudentDetails } from '@/school-management/types/response/studentDetails';
import { getAvatarImage } from './avatarImages';
import SVG from 'react-inlinesvg';
import commonUtils from '@/utils/common';

export interface StudentDataHeaderProps {
  data?: StudentDetails | null;
}

const StudentDataHeader: React.FC<StudentDataHeaderProps> = ({ data }) => {
  const { t } = useAdminTranslation();

  const grade = data?.studentData?.grade;
  const gradeNum = grade ? parseInt(grade, 10) : null;
  const isNoneGrade = gradeNum === 14;

  const img =
    (data?.studentData?.avatar?.avatarName && getAvatarImage(data.studentData.avatar.avatarName)) ||
    '';

  return (
    <div className={styles.studentDataHeader}>
      <div
        className={styles.avatar}
        style={{
          backgroundColor: data?.studentData?.avatar?.avatarColor || '',
        }}
      >
        {img ? (
          <SVG src={img} />
        ) : (
          <span>
            {commonUtils.getInitials(data?.studentData?.firstName, data?.studentData?.lastName)}
          </span>
        )}
      </div>
      <h2>{`${data?.studentData?.firstName} ${data?.studentData?.lastName}`}</h2>
      <div className={styles.details}>
        {isNoneGrade ? (
          <span>{`${t('gradeLabel') + `: ` + t('grade_14')}`}</span>
        ) : (
          <span>{`${t('gradeLabel') + `: ` + commonUtils.getGradeText(grade, t)}`}</span>
        )}
        {data?.studentData?.groupName && (
          <>
            <div className={styles.seperator}></div>
            <span>{data.studentData.groupName}</span>
          </>
        )}
      </div>
    </div>
  );
};

export default StudentDataHeader;
